import React, { useState } from 'react';
import Header from './Header';
import RevendaEmpresasPage from './RevendaEmpresasPage';
import RevendaPage from './RevendaPage';
import RevendaDashboardPage from './RevendaDashboardPage';
import RevendaConsultasPage from './RevendaConsultasPage';

function MenuPrincipalPage({ usuario, empresaSelecionada, cardsMenu, handleVoltar, handleSair }) {
  const [abrirEmpresas, setAbrirEmpresas] = useState(false);
  const [abrirRevenda, setAbrirRevenda] = useState(false);
  const [abrirDashboard, setAbrirDashboard] = useState(false);
  const [abrirConsultas, setAbrirConsultas] = useState(false);

  if (abrirDashboard) {
    return (
      <RevendaDashboardPage
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={() => setAbrirDashboard(false)}
        onSair={handleSair}
      />
    );
  }

  if (abrirEmpresas) {
    return (
      <RevendaEmpresasPage
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={() => setAbrirEmpresas(false)}
        onSair={handleSair}
      />
    );
  }

  if (abrirRevenda) {
    return (
      <RevendaPage
        usuario={usuario}
        revenda={empresaSelecionada}
        onVoltar={() => setAbrirRevenda(false)}
        onSair={handleSair}
      />
    );
  }

  if (abrirConsultas) {
    return (
      <RevendaConsultasPage
        usuario={usuario}
        empresaSelecionada={empresaSelecionada}
        handleVoltar={() => setAbrirConsultas(false)}
        handleSair={handleSair}
      />
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header
        usuario={usuario}
        empresa={empresaSelecionada}
        onVoltar={handleVoltar}
        onSair={handleSair}
      />
      <div className="flex flex-col items-center justify-center mt-16">
        {/* Card Menu Principal */}
        {(empresaSelecionada?.empresa === true || empresaSelecionada?.empresa === 'true' || empresaSelecionada?.empresa === 1 || empresaSelecionada?.empresa === '1') && (
          <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-3xl border border-blue-100 flex flex-col items-center">
            <h2 className="text-2xl font-bold text-blue-700 mb-8">Menu Principal</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full">
              {cardsMenu.map(card => (
                <div
                  key={card.nome}
                  className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300"
                  onClick={card.onClick}
                >
                  {card.icon}
                  <span className="text-lg font-semibold text-blue-800">{card.nome}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        {/* Novo card Menu Revendas */}
        {empresaSelecionada?.revenda === true && (
          <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-3xl border border-blue-100 flex flex-col items-center mt-8">
            <h2 className="text-2xl font-bold text-blue-700 mb-8">Menu Revendas</h2>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full">
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300" onClick={() => setAbrirDashboard(true)}>
                <svg className="w-8 h-8 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 3h18v18H3V3z" /></svg>
                <span className="text-lg font-semibold text-blue-800">Dashboard</span>
              </div>
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300" onClick={() => setAbrirEmpresas(true)}>
                <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m9-4a4 4 0 11-8 0 4 4 0 018 0zm6 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a6 6 0 0112 0z" /></svg>
                <span className="text-lg font-semibold text-green-800">Empresas</span>
              </div>
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300" onClick={() => setAbrirRevenda(true)}>
                <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M8 12h8" /></svg>
                <span className="text-lg font-semibold text-yellow-800">Revenda</span>
              </div>
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300" onClick={() => setAbrirConsultas(true)}>
                <svg className="w-8 h-8 mb-2 text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
                <span className="text-lg font-semibold text-gray-800">Consultas</span>
              </div>
            </div>
          </div>
        )}
        {/* Card Menu Franquias */}
        {(empresaSelecionada?.franquia === true || empresaSelecionada?.franquia === 'true' || empresaSelecionada?.franquia === 1 || empresaSelecionada?.franquia === '1') && (
          <div className="bg-white p-10 rounded-2xl shadow-2xl w-full max-w-3xl border border-blue-100 flex flex-col items-center mt-8">
            <h2 className="text-2xl font-bold text-blue-700 mb-8">Menu Franquias</h2>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 w-full">
              {/* Card Dashboard */}
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300">
                <svg className="w-8 h-8 mb-2 text-blue-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 3h18v18H3V3z" /></svg>
                <span className="text-lg font-semibold text-blue-800">Dashboard</span>
              </div>
              {/* Card Revendas */}
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300">
                <svg className="w-8 h-8 mb-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m9-4a4 4 0 11-8 0 4 4 0 018 0zm6 4v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a6 6 0 0112 0z" /></svg>
                <span className="text-lg font-semibold text-green-800">Revendas</span>
              </div>
              {/* Card Franquia */}
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300">
                <svg className="w-8 h-8 mb-2 text-yellow-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M8 12h8" /></svg>
                <span className="text-lg font-semibold text-yellow-800">Franquia</span>
              </div>
              {/* Card Consultas */}
              <div className="bg-blue-50 rounded-lg shadow-md flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-blue-100 transition border border-blue-300" onClick={() => setAbrirConsultas(true)}>
                <svg className="w-8 h-8 mb-2 text-gray-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>
                <span className="text-lg font-semibold text-gray-800">Consultas</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MenuPrincipalPage; 